import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {PostDO} from '../../common/data-objects/PostDO';

@Component({
  selector: 'app-coloring-thumbnail-post',
  templateUrl: './coloring-thumbnail-post.component.html',
  styleUrls: ['./coloring-thumbnail-post.component.scss']
})
export class ColoringThumbnailPostComponent implements OnInit, OnChanges {
  @Input() postData: PostDO;
  maxTags: string[];
  MAX_TAGS_COUNT = 4;

  constructor() { }

  ngOnInit() {
  }

  get postLink(): string[] {
    return [this.postData.slug];
  }

  get postImage(): string {
    return this.postData.featuredImageSizes.medium ? this.postData.featuredImageSizes.medium : 'assets/logo.svg';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.postData) {
      this.maxTags = this.postData.excerptTags.splice(0, this.MAX_TAGS_COUNT);
    }
  }
}
